import { PdpState } from '@ff-os/pdp-shared-redux/store';
import { prepareArPreview } from './prepareArPreview';

export const activateAr = async (state: PdpState) => {

    const { preview, preview3d, arConfig, gltf } = await prepareArPreview(state);

    await preview3d.embedAndActivateAr(gltf, preview, arConfig);
};